export default "__VITE_ASSET__tzoFobvu__"